import { providersService } from '../services';

export const Local = async () => {
  const { data } = await providersService.getLocalEcm();

  return data;
};
